var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "multiselect",
    {
      attrs: {
        options: _vm.items,
        loading: _vm.isLoadingItems,
        "allow-empty": false,
        "custom-label": _vm.customLabel,
        placeholder: "Zuggesellschaft",
        "track-by": "id",
        "group-values": "items",
        "group-label": "type",
        "select-label": "",
      },
      model: {
        value: _vm.trainSelect,
        callback: function ($$v) {
          _vm.trainSelect = $$v
        },
        expression: "trainSelect",
      },
    },
    [
      _c("template", { slot: "noResult" }, [_vm._v("Kein Ergebnis")]),
      _vm._v(" "),
      _c("span", { attrs: { slot: "caret" }, slot: "caret" }, [
        _c(
          "a",
          {
            staticClass: "multiselect-crud-link",
            attrs: {
              href: "/trains?add",
              title: "Fügen Sie eine neue Gesellschaft hinzu",
              target: "_blank",
            },
          },
          [_c("i", { staticClass: "material-icons" }, [_vm._v("add")])]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }